module.exports = __webpack_public_path__ + "static/media/ck.ae3ea163.svg";